export default "__VITE_ASSET__8mQMSDkY__"